import React, { Component, Fragment } from "react";
import AppContext from "../../../contexts/AppContext";
import { CountryDropdown, RegionDropdown } from 'react-country-region-selector';

export class Billing extends Component {
    
	render() {
        return (
		    <Fragment>
			    <div className="billing-details">
		            {/*<h3 className="mt-5 mb-4">Billing details</h3>*/}
                    <div className="row mt-4">
			            <div className="col-md-6">
			        	    <div className="form-group mb-4">
                                {/*<label htmlFor="fname" className="sr-only">First Name*</label>*/}
                                <input type="text" onChange={this.props.onChangeHandlerFn} value={this.props.item.fname || ''} className="form-control" name="fname" id="fname" ref="fname" placeholder="First Name..." autoComplete="off"/>
								{this.props.errs.fname ? (
									<div className="invalid-feedback">
										{this.props.errs.fname}
									</div>
								) : null}
                            </div>
			        	</div>
			        	<div className="col-md-6">
			        	    <div className="form-group mb-4">
                                {/*<label htmlFor="lname" className="sr-only">Last Name*</label>*/}
                                <input type="text" onChange={this.props.onChangeHandlerFn} value={this.props.item.lname || ''} className="form-control" name="lname" id="lname" ref="lname" placeholder="Last Name..." autoComplete="off" />
								{this.props.errs.lname ? (
									<div className="invalid-feedback">
										{this.props.errs.lname}
									</div>
								) : null}
                            </div>
			        	</div>
			        	{/*<div className="col-12">
			        	    <div className="form-group mb-4">
                                <label htmlFor="email" className="sr-only">Email Address*</label>
                                <input type="email" onChange={this.props.onChangeHandlerFn} value={this.props.item.email || ''} className="form-control" name="email" id="email" ref="email" placeholder="Email Address*" autoComplete="off" />
								{this.props.errs.email ? (
									<div className="invalid-feedback">
										{this.props.errs.email}
									</div>
								) : null}
                            </div>
			        	</div>*/}
			        	<div className="col-12">
			        	    <div className="form-group mb-4">
                                {/*<label htmlFor="address" className="sr-only">Street Address*</label>*/}
                                <input type="text" onChange={this.props.onChangeHandlerFn} value={this.props.item.address || ''} className="form-control" name="address" id="address" ref="address" placeholder="Full Address..." autoComplete="off" />
								{this.props.errs.address ? (
									<div className="invalid-feedback">
										{this.props.errs.address}
									</div>
								) : null}
                            </div>
			        	</div>
			        	<div className="col-12">
			        	    <div className="form-group mb-4">
                                {/*<label htmlFor="city" className="sr-only">Town/City*</label>*/}
                                <input type="text" onChange={this.props.onChangeHandlerFn} value={this.props.item.city || ''} className="form-control" name="city" id="city" ref="city" placeholder="City Name..." autoComplete="off" />
								{this.props.errs.city ? (
									<div className="invalid-feedback">
										{this.props.errs.city}
									</div>
								) : null}
                            </div>
			        	</div>
						<div className="col-12">
						    <div className="form-group select mb-4">
								<CountryDropdown
									defaultOptionLabel="Select Country"
									value={this.props.item.country}										
									whitelist={["CA", "US"]}
									classes= "form-control m-input center-select"								
									onChange={(val) => this.props.selectCountry(val)} />
			        	        {/* <select className="form-control m-input center-select" onChange={this.props.onChangeHandlerFn} value={this.props.country} name="country">
									<option value="" >Country*</option>
									<option value="US" >US</option>
                                </select> */}
								{this.props.errs.country ? (
									<div className="invalid-feedback">
										{this.props.errs.country}
									</div>
								) : null}
							</div>
			        	</div>
						<div className="col-md-6">
			        	    <div className="form-group select mb-4">
							    {/* <select className="form-control m-input center-select" onChange={this.props.onChangeHandlerFn} name="province" value={this.props.province}>
                                    <option value="" >State*</option>
									<option value="Alabama">Alabama</option><option value="Alaska">Alaska</option><option value="Arizona">Arizona</option><option value="Arkansas">Arkansas</option><option value="California">California</option><option value="Colorado">Colorado</option><option value="Connecticut">Connecticut</option><option value="Delaware">Delaware</option><option value="District of Columbia">District of Columbia</option><option value="Florida">Florida</option><option value="Georgia">Georgia</option><option value="Guam">Guam</option><option value="Hawaii">Hawaii</option><option value="Idaho">Idaho</option><option value="Illinois">Illinois</option><option value="Indiana">Indiana</option><option value="Iowa">Iowa</option><option value="Kansas">Kansas</option><option value="Kentucky">Kentucky</option><option value="Louisiana">Louisiana</option><option value="Maine">Maine</option><option value="Maryland">Maryland</option><option value="Massachusetts">Massachusetts</option><option value="Michigan">Michigan</option><option value="Minnesota">Minnesota</option><option value="Mississippi">Mississippi</option><option value="Missouri">Missouri</option><option value="Montana">Montana</option><option value="Nebraska">Nebraska</option><option value="Nevada">Nevada</option><option value="New Hampshire">New Hampshire</option><option value="New Jersey">New Jersey</option><option value="New Mexico">New Mexico</option><option value="New York">New York</option><option value="North Carolina">North Carolina</option><option value="North Dakota">North Dakota</option><option value="Northern Marianas Islands">Northern Marianas Islands</option><option value="Ohio">Ohio</option><option value="Oklahoma">Oklahoma</option><option value="Oregon">Oregon</option><option value="Pennsylvania">Pennsylvania</option><option value="Puerto Rico">Puerto Rico</option><option value="Rhode Island">Rhode Island</option><option value="South Carolina">South Carolina</option><option value="South Dakota">South Dakota</option><option value="Tennessee">Tennessee</option><option value="Texas">Texas</option><option value="Utah">Utah</option><option value="Vermont">Vermont</option><option value="Virginia">Virginia</option><option value="Virgin Islands">Virgin Islands</option><option value="Washington">Washington</option><option value="West Virginia">West Virginia</option><option value="Wisconsin">Wisconsin</option><option value="Wyoming">Wyoming</option>
                                </select> */}
								 <RegionDropdown
								 	blankOptionLabel="State/Province..."
									defaultOptionLabel="Select Province"
									classes= "form-control m-input center-select"	
									country={this.props.item.country}
									value={this.props.item.province}
									onChange={(val) => this.props.selectRegion(val)} />
								{this.props.errs.province ? (
									<div className="invalid-feedback">
										{this.props.errs.province}
									</div>
								) : null}
							</div>
			        	</div>
			        	<div className="col-md-6">
			        	    <div className="form-group mb-4">
                                {/*<label htmlFor="zip" className="sr-only">ZIP*</label>*/}
                                <input type="text" pattern="\d*" onChange={this.props.onChangeHandlerFn} value={this.props.item.zip || ''} className="form-control" name="zip" id="zip" ref="zip" placeholder="Zip Code..." autoComplete="off" />
								{this.props.errs.zip ? (
									<div className="invalid-feedback">
										{this.props.errs.zip}
									</div>
								) : null}
                            </div>
			        	</div>
			        </div>
				</div>	
			</Fragment>	
		);
        
    }
}

Billing.contextType = AppContext;
export default Billing;



// WEBPACK FOOTER //
// ./src/components/general/include/Billing.js